import AdminLayout from './adminLayout.vue'

export default AdminLayout
